import React from "react"
import { Button } from "react-bootstrap"

import { isPresent } from "@/utils"

const SaveButton = ({ label = "Save", ...props }): JSX.Element => {
  const iconClassName = isPresent(label) ? "fas fa-save me-2" : "fas fa-save"

  return (
    <Button {...props}>
      <span className={iconClassName} />
      {label}
    </Button>
  )
}

export default SaveButton
